import React, { Component } from 'react';
import VentaCompletada from '../components/VentaCompletada';

class VentaCompletadaScreen extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <VentaCompletada />
    )
  }
}
export default VentaCompletadaScreen